var SpriteSymbol = require("../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/.pnpm/rspack-svg-sprite-loader@6.0.12/node_modules/rspack-svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "icon-sprite-icon_pay_fail",
  "use": "icon-sprite-icon_pay_fail-usage",
  "viewBox": "0 0 108 108",
  "content": "<symbol viewBox=\"0 0 108 108\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sprite-icon_pay_fail\"><g stroke=\"#E64848\" stroke-width=\"6\" fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"54\" cy=\"54\" r=\"51\" /><path d=\"M35 73l38-38m0 38L35 35\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol